export default __webpack_public_path__ + "static/media/Megosu-KarTent-Gif.74d9598d.png";